import { navigate } from 'gatsby';
const CLIENT_ID = process.env.GATSBY_LINKEDIN_CLIENT_ID;
const LINKEDIN_OAUTH_URL = 'https://www.linkedin.com/oauth/v2/authorization';
const SCOPE = encodeURIComponent('email profile openid');
const REDIRECT_URL = encodeURIComponent(
  `${process.env.GATSBY_SITE_URL}/linkedin/verify/`
);
const useLinkedIn = () => {
  /**
   * This will trigger LinkedIn Login
   * @param state - this can be actually anything, recommended to have something like random token
   */
  const oAuth2Login = (state) => {
    navigate(
      `${LINKEDIN_OAUTH_URL}?response_type=code&client_id=${CLIENT_ID}&redirect_uri=${REDIRECT_URL}&state=${state}&scope=${SCOPE}`
    );
  };
  return {
    oAuth2Login,
  };
};

export default useLinkedIn;
